module.exports = __webpack_public_path__ + "images/201f1938ed01a55dcc1ba253babd5213-WPIC logo.jpg";